// /*** @description:卫星通信材质* @date: 2023年6月17日10:43:18*/
// function SatelliteMaterialProperty(options) {// 默认参数设置this._definitionChanged = new Cesium.Event();this.color = options.color;
// }
// Object.defineProperties(SatelliteMaterialProperty.prototype, {
//     isConstant: { get: function () { return false; } }, definitionChanged: { get: function () { return this._definitionChanged; } }, color: Cesium.createPropertyDescriptor('color')
// });
// SatelliteMaterialProperty.prototype.getType = function (time) {
//     return 'SatelliteMaterial';
// };
// SatelliteMaterialProperty.prototype.getValue = function (time, result) {
//     if (!Cesium.defined(result)) { result = {}; } result.color = Cesium.Property.getValueOrClonedDefault(this._color, time, Cesium.Color.WHITE, result.color); viewer.scene.requestRender(); return result;
// };
// SatelliteMaterialProperty.prototype.equals = function (other) {
//     return this === other || (other instanceof SatelliteMaterialProperty && Cesium.Property.equals(this._color, other._color));
// };
// Cesium.Material.SatelliteType = 'SatelliteMaterial';
// Cesium.Material.SatelliteSource = `uniform vec4 color;uniform float speed;uniform float percent;uniform float gradient;uniform float count;czm_material czm_getMaterial(czm_materialInput materialInput){czm_material material = czm_getDefaultMaterial(materialInput);vec2 st = materialInput.st;float t =fract(czm_frameNumber * speed / 1000.0);float v = 1.0-(1.0-smoothstep(gradient,0.0,fract(st.x*count-t)))*0.95;material.diffuse = color.rgb/10.0 + vec3(v)*9.0;material.alpha = color.a;return material;}`;
// Cesium.Material._materialCache.addMaterial(Cesium.Material.SatelliteType, {

//     fabric: {
//         type: Cesium.Material.SatelliteType,
//         uniforms: {
//             color: new Cesium.Color(1.0, 0.0, 1.0, 0.1),
//             speed: 30.0, 
//             gradient: 0.2, 
//             count: 15,
//         },
//         source: Cesium.Material.SatelliteSource
//     },
//     translucent: function (material) {
//         return true;
//     }
// });





class SatelliteMaterialProperty {
    constructor(options) {
        this._definitionChanged = new Cesium.Event();
        this.color = options.color; //颜色
        this.backgroundColor = options.backgroundColor; //颜色
        this.speed = options.speed; //速度
        this.gradient = options.gradient; //梯度
        this.count = options.count; //数量
    };

    get isConstant() {
        return false;
    }

    get definitionChanged() {
        return this._definitionChanged;
    }

    getType(time) {
        return Cesium.Material.SatelliteMaterialType;
    }

    getValue(time, result) {
        if (!Cesium.defined(result)) {
            result = {};
        }
        result.backgroundColor = Cesium.Property.getValueOrDefault(this.backgroundColor, time, Cesium.Color.RED, result.backgroundColor);
        result.color = Cesium.Property.getValueOrDefault(this.color, time, Cesium.Color.RED, result.color);
        result.speed = Cesium.Property.getValueOrDefault(this.speed, time, 30, result.speed);
        result.gradient = Cesium.Property.getValueOrDefault(this.gradient, time, 0.2, result.gradient);
        result.count = Cesium.Property.getValueOrDefault(this.count, time, 15, result.count);
        return result
    }

    equals(other) {
        return (this === other ||
            (other instanceof SatelliteMaterialProperty &&
                Cesium.Property.equals(this.color, other.backgroundColor) &&
                Cesium.Property.equals(this.color, other.color) &&
                Cesium.Property.equals(this.speed, other.speed) &&
                Cesium.Property.equals(this.gradient, other.gradient) &&
                Cesium.Property.equals(this.count, other.count))
        )
    }
}

Object.defineProperties(SatelliteMaterialProperty.prototype, {
    color: Cesium.createPropertyDescriptor('color'),
    backgroundColor: Cesium.createPropertyDescriptor('backgroundColor'),
    speed: Cesium.createPropertyDescriptor('speed'),
    gradient: Cesium.createPropertyDescriptor('gradient'),
    count: Cesium.createPropertyDescriptor('count'),
})

export default SatelliteMaterialProperty;
